import List from "./List";
export { default as MockList } from "./mock";
export default List;